import { render } from "./ClientForm.vue?vue&type=template&id=32223102"
import script from "./ClientForm.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./ClientForm.vue?vue&type=script&charset=utf-8&lang=js"
script.render = render

export default script